<div class="w-full">
    <h1 class="font-bold text-xl mb-4">Finalizar Gestión: </h1>
    <form #form="ngForm" action="">
        <mat-form-field class="fuse-mat-dense w-full">
            <mat-label>Número de documento oficial</mat-label>
            <input matInput 
                    name="codigoDocumento"
                    id="codigoDocumento" type="text" required
                    [(ngModel)]="payloadGestionCompletada.codigoDocumento"/>
        </mat-form-field>  

        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
                <mat-label>Fecha inicio de vigencia</mat-label>
                <input matInput id="fechaInicioVigencia" type="date" name="fechaInicioVigencia"
                       [(ngModel)]="payloadGestionCompletada.fechaInicioVigencia">
            </mat-form-field>

            <mat-form-field class="fuse-mat-dense flex-1 w-full md:w-auto">
                <mat-label>Fecha fin de vigencia</mat-label>
                <input matInput id="fechaFinVigencia" type="date" name="fechaFinVigencia"
                       [(ngModel)]="payloadGestionCompletada.fechaFinVigencia">
            </mat-form-field>
        </div>

        <mat-form-field class="fuse-mat-dense w-full">
            <mat-label>Elaborado Por</mat-label>
            <input matInput 
                    name="generadoPor"
                    id="generadoPor" type="text" required
                    [(ngModel)]="payloadGestionCompletada.generadoPor"/>
        </mat-form-field>  

        <mat-form-field class="fuse-mat-dense w-full">
            <mat-label>Plantilla</mat-label>
            <mat-select name="plantilla"
                        [(ngModel)]="payloadGestionCompletada.plantilla"
                        required>
                <mat-option *ngFor="let p of plantillas" [value]="p.plantillaId">
                    {{ p.nombreDocumento }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
 
    <div
        class="flex flex-col items-center justify-center relative w-full h-20 md:h-28 bg-gray-100 border-2 border-dashed border-gray-300 p-2 rounded-md"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        
            <div class="font-bold mb-2 hidden md:flex">Seleccione un Archivo o Arrastrelo Aquí</div>
            <button (click)="uploadImage()" class="w-8/12 md:w-4/12 h-12 border border-gray-300 rounded-md flex items-center justify-center bg-[#f4f4f4] hover:bg-[#e0e0e0]">
            <mat-icon class="">cloud_upload</mat-icon>
            <p class="pl-2 text-sm md:text-md">Seleccionar Archivo</p>
            </button>
    
            <input
            type="file"
            accept=".pdf,
                    application/pdf"
            (change)="onFileSelected($event)"
            class="hidden"
            #fileInput
            required>
            
        <p class="text-xs font-semibold mt-2">{{ nombreDocumentoSeleccionado }} </p>
    </div>
    
    <hr>

    <div class="w-full flex justify-end gap-3 mt-3">
        <button mat-button mat-raised-button
        class=""  
        [color]="'secondary'" (click)="this.dialogRef.close(false);">
        Cancelar
        </button>

        <button mat-flat-button 
            [color]="'primary'" (click)="finalizarYEnviar()"
            [disabled]="form.invalid || !payloadGestionCompletada.documentoFirmado || isSubmitting">
            <span *ngIf="!isSubmitting">Finalizar y enviar</span>
            <span *ngIf="isSubmitting" class="flex items-center gap-2">
                <mat-icon class="animate-spin">autorenew</mat-icon>
                Enviando...
            </span>
        </button>
    </div>
</div>
